import { Button, Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { EmailIcon } from '../../components/CustomIcons';
import CustomSection from '../../components/CustomSection';
import { paths } from '../../config/router.config';
import theme from '../../theme.css';

const useStyles = makeStyles((theme) => ({
    main: {
        padding: theme.spacing(2),
        background: theme.palette.common.white,
    },
}));

export default function NotificationDetailView(props){
    const classes = useStyles();
    const {t} = useTranslation();
    const history = useHistory();

    const [detail, setDetail] = useState(null);
    const { location } = props;

    useEffect(() => {
        if(location && location.state && location.state.detail) {
            setDetail(location.state.detail);
        }
    }, []);

    const onGoBack = () => {
        history.push(paths.notifications);
    }

    return (
        <Grid item xs={12} className={classes.main}>
            <CustomSection notMarginTop={true} 
                title={t('notifications_detail')} 
                icon={<EmailIcon style={{
                    color: theme.palette.common.white,
                }}/>}
            >
                <Grid item xs={12} container direction='row' spacing={1}>
                    <Grid item xs={12} sm={3} className={classes.label}>
                        <Typography variant='body2'>{t('no_detail_number')}</Typography>
                    </Grid>
                    {detail && <Grid item xs={12} sm={9} className={classes.content}>
                        <Typography variant='body1'>{detail.number ? detail.number : null}</Typography>
                    </Grid>}
                </Grid>
                <Grid item xs={12} container direction='row' spacing={1}>
                    <Grid item xs={12} sm={3} className={classes.label}>
                        <Typography variant='body2'>{t('no_detail_date')}</Typography>
                    </Grid>
                    {detail && <Grid item xs={12} sm={9} className={classes.content}>
                        <Typography variant='body1'>{detail.date ? detail.date : null}</Typography>
                    </Grid>}
                </Grid>
                <Grid item xs={12} container direction='row' spacing={1}>
                    <Grid item xs={12} sm={3} className={classes.label}>
                        <Typography variant='body2'>{t('no_detail_subject')}</Typography>
                    </Grid>
                    {detail && <Grid item xs={12} sm={9} className={classes.content}>
                        <Typography variant='body1'>{detail.subject ? detail.subject : null}</Typography>
                    </Grid>}
                </Grid>
                <Grid item xs={12} container direction='row' spacing={1}>
                    <Grid item xs={12} sm={3} className={classes.label}>
                        <Typography variant='body2'>{t('no_detail_content')}</Typography>
                    </Grid>
                    {detail && <Grid item xs={12} sm={9} className={classes.content}>
                        <Typography variant='body1'>{detail.content ? detail.content : null}</Typography>
                    </Grid>}
                </Grid>
                <Grid item xs={12} marginTop={5}>
                    <Button variant='text' onClick={() => onGoBack()}>{t('btn_back')}</Button>
                </Grid>
            </CustomSection>
        </Grid>
    );
}